import { AxiosError, AxiosResponse } from 'axios';
import { axiosPrivate, axiosPublic } from './client';
import { logout } from 'store';
import toast from 'shared/utils/toast';

let store;

export const injectStore = (_store) => {
  store = _store;
};

export const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

/**
 * Global HTTP Private Response Error Interceptor & Authentication Middleware.
 *
 * Intercepts all failed authenticated network requests made via `axiosPrivate`.
 * Implements a silent JWT token rotation mechanism on 401 Unauthorized faults,
 * routes infrastructure crashes (502 Gateway errors) to a static maintenance layout
 * in production, and sanitizes application business logic errors through the toast engine.
 *
 * @param {AxiosError} error - The raw operational exception artifact thrown by Axios.
 * @returns {Promise<AxiosResponse | AxiosError>} Resolves with a retried request instance on successful refresh,
 * or re-throws the underlying rejection matrix to the calling UI layer.
 * @throws {AxiosError} Re-throws the network exception to maintain upstream component lifecycle control.
 *
 * @example
 * axiosPrivate.interceptors.response.use(onResponse, onResponseError);
 */
export const onResponseError = async (error: AxiosError): Promise<AxiosError> => {
  if (error?.response?.config?.url === 'logout/') return;
  if (error?.response?.status === 401) {
    try {
      await axiosPublic.post('token/refresh/', {}, { withCredentials: true });
      return axiosPrivate.request(error.config);
    } catch (err) {
      store.dispatch(logout());
    }
  } else if (error?.response?.status === 502 && !(process.env.NODE_ENV === 'development')) {
    window.location.replace('/maintenance');
    // toast.error(JSON.stringify(error?.response?.data).slice(0, 255));
    toast.error('Il server è momentaneamente in manutenzione. Riprova più tardi.');
  } else {
    toast.apiError(error);
  }
  throw error;
};

// Registriamo l'intercettore direttamente sull'istanza privata importata
axiosPrivate.interceptors.response.use(onResponse, onResponseError);
